import { useEffect, useState } from 'react';
import { RawGoal } from '@views';
import { EmptyFunction } from '@utils/common-types';
import { useCreateGoalAction } from '@actions/CreateGoalAction';
import { useOnboardingSurveyViewCreator } from '@viewCreators/onboarding-survey-view-creator';
import { useSurveyDrawerController } from '@components/SurveyDrawer/useSurveyDrawerController';

export const useUpdateGoalsDialogController = (cohortUserId: number, groupId: number, refresh: EmptyFunction) => {
  const [showNewGoalDialog, setShowNewGoalDialog] = useState<boolean>(false);
  const [rawGoals, setRawGoals] = useState<RawGoal[]>([]);
  const { data, isLoading } = useOnboardingSurveyViewCreator(groupId);
  const { mutateAsync: createGoals } = useCreateGoalAction();
  const { saveResponses } = useSurveyDrawerController(groupId);
  const saveGoals = async (e: any, reason: 'SAVE' | 'CANCEL', goals: RawGoal[]) => {
    await createGoals(goals);
    saveResponses();
    setShowNewGoalDialog(false);
    refresh();
  };

  useEffect(() => {
    if (data && !isLoading) {
      const showGoalDialog = data.id === 1;
      setShowNewGoalDialog(showGoalDialog);
    }
  }, [data, isLoading]);

  return {
    handleShowNewGoalDialog: () => setShowNewGoalDialog(true),
    showNewGoalDialog,
    submitGoals: saveGoals,
    rawGoals,
    setRawGoals,
  };
};
